<template>
  <layout-admin current="referrals">
    <div class="referrals">
      <div class="panel">
        <div class="panel__head">
          <h1>New code</h1>
        </div>
        <form class="form is-compact" @submit.prevent="create">
          <p v-for="(error, key) in errors" :key="key" class="form__error">{{ message(error) }}</p>
          <div class="form__row is-three">
            <label>
              Name
              <input v-model="form.name" type="text" maxlength="120" required>
            </label>
            <label>
              Code
              <input v-model="form.code" type="text" maxlength="32" autocapitalize="off" spellcheck="false" required>
            </label>
            <label>
              Landing path
              <input v-model="form.landing_path" type="text" maxlength="200" placeholder="/" spellcheck="false">
            </label>
          </div>
          <div class="form__line">
            <label>
              Notes
              <textarea v-model="form.notes" maxlength="2000" rows="1"></textarea>
            </label>
            <button class="btn is-view" type="submit" :disabled="creating">Create</button>
          </div>
        </form>
      </div>

      <div class="panel">
        <div class="panel__head">
          <h1>Referrals</h1>
          <span>{{ referrals.length }}</span>
        </div>

        <div v-if="!referrals.length" class="panel__empty">No referral codes yet.</div>

        <div v-else class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Code</th>
                <th>Status</th>
                <th class="num">7d clicks</th>
                <th class="num">7d visitors</th>
                <th class="num">30d clicks</th>
                <th class="num">30d visitors</th>
                <th class="num">30d leads</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in referrals" :key="item.id">
                <td>
                  <Link :href="route('admin.referrals.show', item.id)" class="link">{{ item.name }}</Link>
                </td>
                <td class="mono">{{ item.code }}</td>
                <td>
                  <span class="pill" :class="item.active ? 'is-on' : 'is-off'">
                    {{ item.active ? 'Active' : 'Paused' }}
                  </span>
                </td>
                <td class="num">{{ item.week.clicks }}</td>
                <td class="num">{{ item.week.uniques }}</td>
                <td class="num">{{ item.month.clicks }}</td>
                <td class="num">{{ item.month.uniques }}</td>
                <td class="num">{{ item.leads }}</td>
                <td class="actions">
                  <button type="button" class="btn" @click="copy(item.short_url)">
                    {{ copied === item.short_url ? 'Copied' : 'Copy link' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </layout-admin>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import LayoutAdmin from '@/Layouts/Admin.vue';

export default {
  components: {
    LayoutAdmin,
    Link
  },

  props: {
    referrals: { type: Array, required: true }
  },

  data() {
    return {
      creating: false,
      copied: '',
      form: {
        name: '',
        code: '',
        landing_path: '',
        notes: ''
      }
    };
  },

  computed: {
    errors() {
      return this.$page.props.errors || {};
    }
  },

  methods: {
    create() {
      if (this.creating) {
        return;
      }

      this.creating = true;
      this.$inertia.post(this.route('admin.referrals.store'), this.form, {
        onSuccess: () => {
          this.form = {
            name: '',
            code: '',
            landing_path: '',
            notes: ''
          };
        },
        onFinish: () => {
          this.creating = false;
        }
      });
    },

    message(error) {
      return Array.isArray(error) ? error[0] : error;
    },

    copy(url) {
      const done = () => {
        this.copied = url;
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done);

        return;
      }

      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      done();
    }
  }
};
</script>

<style lang="scss" scoped>
.referrals {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1rem;
  min-height: 0;
}

.panel:first-child {
  flex: none;

  .form__row.is-three {
    grid-template-columns: 1fr 0.7fr 1fr;
  }

  .form__line {
    align-items: flex-end;
    display: flex;
    gap: 0.75rem;

    label {
      flex: 1;
      min-width: 0;
    }
  }
}

.panel:last-child {
  flex: 1;
}
</style>
